import { useState, useEffect } from "react";
import API from "@/lib/api";

// Debounced lookup of a User ID (referral code) -> name, to confirm identity.
export function useNameLookup(code) {
  const [state, setState] = useState({ status: "idle", name: "" }); // idle | found | notfound

  useEffect(() => {
    const c = (code || "").trim();
    if (!c) { setState({ status: "idle", name: "" }); return; }
    let active = true;
    const t = setTimeout(async () => {
      try {
        const r = await API.get(`/lookup/${encodeURIComponent(c)}`);
        if (!active) return;
        setState(r.data.found
          ? { status: "found", name: r.data.name, data: r.data }
          : { status: "notfound", name: "", data: null });
      } catch {
        if (active) setState({ status: "idle", name: "" });
      }
    }, 400);
    return () => { active = false; clearTimeout(t); };
  }, [code]);

  return state;
}
